export const slideItems = [
  {
    id: 1,
    img: 'https://www.pngkey.com/png/full/289-2897985_eye-makeup-png-for-kids-transparent-background-eyeshadow.png',
    title: 'BLACK FRIDAY',
    desc: 'СКИДКИ ДО 30% НА ПРЕМИАЛЬНЫЕ ПРОДУКТЫ',
    bg: 'rgb(201, 134, 175)',
  },
  {
    id: 2,
    img: 'https://www.vippng.com/png/full/144-1447892_83315-swatch-elf-monochromatic-multi-stick-swatches.png',
    title: 'ЭКСКЛЮЗИВ',
    desc: 'БУДЬ ПЕРВОЙ ,ЭКСКЛЮЗИВНЫЕ  ТОВАРЫ',
    bg: 'fcf1ed',
  },
  {
    id: 3,
    img: 'https://www.mecca.com.au/on/demandware.static/-/Sites-mecca-online-catalog/default/dw4a013ca3/product/ilia/tx/i-040011-the-necessary-eyeshadow-palette-cool-nude-4-940.png',
    title: 'БЕСТСЕЛЛЕРЫ',
    desc: 'ТОП ПРОДАЖ, ТОВАРЫ ПРИЗНАННЫЕ ТЫСЯЧАМИ',
    bg: 'fcf1ed',
  },
];

export const category = [
  {
    id: 1,
    img: 'https://www.skincenterofsouthmiami.com/wp-content/uploads/2018/06/Skin-Center-of-South-Miami-Facials-and-Skin-Care.jpg',
    title: 'УХОД ЗА КОЖЕЙ!',
    cat:"care"
  },
  {
    id: 2,
    img: 'https://skinnyms.com/wp-content/uploads/2016/01/Hair_Care_Tips.jpg',
    title: 'ВСЁ ДЛЯ ВОЛОС!',
    cat: "hair"
  },
  {
    id: 3,
    img: 'https://i.redd.it/91x85sphbzr51.jpg',
    title: 'МАКИЯЖ!',
    cat:"makeup"
  },
];
export const popular = [
  {
    id: '1',
    name: 'YVES SAINT LAURENT COUTURE EYE LINER Жидкая подводка для глаз',
    desc: 'Couture Eyeliner - это первая жидкая подводка, обогащенная тройным комплексом для роста ресниц. Инновационная стойкая формула подводки идеально подходит для осеннего сезона.',
    image: 'https://static.iledebeaute.ru/files/images/tag/part_12/252791/pre/500_500sb.jpg',
    price: 3250,
    category: 1
  },
  {
    id: 2,
    name: 'SERIE EXPERT ABSOLUT REPAIR Шампунь для восстановления поврежденных волос',
    desc:'Шампунь мягко очищает поврежденные волосы, не пересушивая их в процессе мытья.',
    image: 'https://static.iledebeaute.ru/files/images/tag/part_19/386209/pre/500_500sb.jpg',
    price:1300,
    category: 2
  },
  {
    id: 3,
    name:'CLARINS Addition Concentre Eclat Visage Концентрат с эффектом загара для лица',
    desc:'Уникальное средство, сочетающее простоту использования и безупречный результат. ',
    image:'https://static.iledebeaute.ru/files/images/tag/part_19/384781/pre/500_500sb.jpg',
    price:2240,
    category: 3
  },
  {
    id: 4,
    name:'SHISEIDO WASO Очищающее трио Перезагрузка',
    desc:'Детокс для кожи и причина для хорошего настроения! ',
    image:'https://static.iledebeaute.ru/files/images/tag/part_19/384061/pre/500_500sb.jpg',
    price:2450,
    category: 3
  },
  {
    id: 5,
    name:'NEW NUDE PALETTE',
    desc: 'Революционные текстуры и оттенки, которые кардинально меняет представление о естественном макияже глаз',
    image:'https://static.iledebeaute.ru/files/images/tag/part_15/303962/pre/500_500sb.jpg',
    price:6930,
    category: 1
  },
  {
    id: 6,
    name:'YVES SAINT LAURENT COUTURE COLOUR CLUTCH PALETTE TUXEDO Палетка теней для век',
    desc: 'Новая палетка теней для век Couture Colour Clutch Palette Tuxedo из коллекции Le Smokey для макияжа глаз от бренда YSL Beauty',
    image:'https://static.iledebeaute.ru/files/images/tag/part_19/392455/pre/500_500sb.jpg',
    price: 7930,
    category: 1
  },
  {
    id: 7,
    name: 'ESTEE LAUDER Pure Color Envy Губная помада',
    desc: 'Моделирует форму губ: многогранные частицы пигмента помогают создать яркий образ. Губы приобретают соблазнительную форму и изгиб.',
    image:'https://static.iledebeaute.ru/files/images/tag/part_16/337324/pre/257_257sb.jpg',
    price: 3120,
    category: 1
  },
  {
    id: 8,
    name: 'TANGLE TEEZER Крем-спрей для легкого расчесывания волос Everyday Detangling Cream Spray',
    desc:'Крем-спрей для легкого расчесывания волос Tangle Teezer Everyday Detangling Cream Spray создан для густых, кудрявых и вьющихся волос.',
    image: 'https://static.iledebeaute.ru/files/images/tag/part_18/366392/pre/500_500sb.jpg',
    price:1450,
    category: 2
  },
];
